import React, { useState } from "react";

import Modal from "../modal/Modal";
import { hasRoles } from "../../utils/roles";
import isEmpty from "../../validation/is-empty";
import PropTypes from "prop-types";

import "../project-drawings/ProjectDrawingUploaderModal.css";
import { translate } from "../../utils/translation";
import {
  uploadKeyDocument,
  deleteKeyDocument,
} from "../../api/post-contract/KeyDocumentsAPI";
import UploadModal from "../common/UploadModal.components";
import { DeletePDFButton } from "../pdf/PdfDelete.components";

PostContractKeyDocsUpload.propTypes = {
  project: PropTypes.object,
  selectedReport: PropTypes.object,
  user: PropTypes.object,
  postContract: PropTypes.object,
};

export default function PostContractKeyDocsUpload(props) {
  const { project } = props;
  const { selectedReport } = props;
  const { user } = props;
  const { postContract } = props;

  const [modal, setModal] = useState(false);

  if (!window.location.href.includes("Key%20Documents")) {
    return null;
  }

  if (project.project_phase !== "POST_CONTRACT") {
    return null;
  }

  if (!hasRoles(user.roles, ["CostManager"])) {
    return null;
  }

  // No Post Contrct selected
  if (isEmpty(selectedReport)) {
    return null;
  }

  const data = {
    projectId: project.id,
    project: project,
    postContractId: selectedReport.Id,
    postContract: postContract,
    setShow: setModal,
  };

  return (
    <div>
      <Modal
        // Modal Props
        title={translate("Upload Documents")}
        Component={KeyDocsUploadModal}
        modal={modal}
        setModal={setModal}
        // Component Props
        data={data}
        uploadFunction={uploadKeyDocument}
      />
      <button
        className="cost-planning-subtotal-open"
        onClick={() => {
          setModal(true);
        }}
      >
        {translate("Upload PDF")}
      </button>
    </div>
  );
}

KeyDocsUploadModal.propTypes = {
  data: PropTypes.object,
  uploadFunction: PropTypes.func,
};
function KeyDocsUploadModal(props) {
  const { data } = props;
  const { uploadFunction } = props;
  return (
    <div className="pdu-container">
      <UploadModal data={data} uploadFunction={uploadFunction} />
    </div>
  );
}

DeletePCKeyDocButton.propTypes = {
  user: PropTypes.object,
  project: PropTypes.object,
  postContract: PropTypes.object,
  postContractId: PropTypes.string,
  documentId: PropTypes.string,
};

export function DeletePCKeyDocButton(props) {
  const { documentId, postContractId } = props;
  const { user } = props;
  const { project, postContract } = props;

  if (!hasRoles(user.roles, ["CostManager"])) {
    return null;
  }

  if (project.project_phase !== "POST_CONTRACT") {
    return null;
  }
  return (
    <div>
      <DeletePDFButton
        updateFunction={async () => {
          // Delete Drawing
          await deleteKeyDocument(documentId, project.id, postContractId);
          // Refresh Post Contract
          postContract.set(
            await postContract.get(project.id, postContractId, "Key Documents")
          );
        }}
      />
    </div>
  );
}
